/** biome-ignore-all lint/nursery/noRestrictedElements: imported on every page so minimizing bundle */
'use client';

import { useRouter } from 'next/navigation';
import { SearchBar } from './SearchBar';

export const NotFound = () => {
  const router = useRouter();

  return (
    <>
      <div className='flex flex-col justify-center my-[30px] mx-auto relative w-[65%]'>
        <button
          className='flex self-start items-center cursor-pointer relative top-0 left-[-48px] typography-level-5 font-semibold text-primary-hover'
          // unfortunately cannot get around using this as much as i want to kill it
          onClick={() => router.back()}
          type='button'
        >
          {/** biome-ignore lint/style/useConsistentCurlyBraces: it needs it. don't try to remove it trust me */}
          {'<'} Back
        </button>
        <h1 className='typography-lg font-inria-serif font-bold text-center my-12'>Oops! Page not found</h1>
        <p className='text-secondary typography-level-4 px-[5vw] py-[1vw]'>
          Our apologies. It may have expired or there could be a typo. Search for what you are looking for or find what
          you need on our{' '}
          <a
            className='text-blue-500 dark:text-blue-300 hover:text-primary-hover active:text-primary-pressed visited:text-primary-visited'
            href='https://fortune.com'
          >
            homepage
          </a>
          .
        </p>
      </div>
      <SearchBar />
    </>
  );
};
